import { render } from "./AdminErrors.component.vue?vue&type=template&id=02e88dd6&scoped=true"
import script from "./AdminErrors.component.vue?vue&type=script&lang=js"
export * from "./AdminErrors.component.vue?vue&type=script&lang=js"

import "./AdminErrors.component.vue?vue&type=style&index=0&id=02e88dd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e88dd6"]])

export default __exports__